export default __webpack_public_path__ + "static/4-09cf4848cd5918b8517eb4130616af38.png";